import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SideMenu, TopMenu } from 'maxcu-shared-lib';
import './ReviewOffer.css';
import menuItems from '../SideMenu/menuItems';

const ReviewOffer = () => {
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        // Set the browser title
        document.title = 'My Offers | MAX Credit Union';
      }, []);
    
    const [formData, setFormData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [disclosureAccepted, setDisclosureAccepted] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);


  
    const handleResize = () => {
      if (window.innerWidth < 600) {
        setIsCollapsed(true);
      } else {
        setIsCollapsed(false);
      }
    };
  
    useEffect(() => {
      handleResize(); // Initial check
      window.addEventListener('resize', handleResize);
      
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    useEffect(() => {
        // Parse URL parameters to get form data
        const params = new URLSearchParams(location.search);
        const data = {};
        for (let [key, value] of params.entries()) {
            data[key] = value;
        }
        
        setFormData(data);
    }, [location]);

    const incomeFrequencyMap = {
        '324': 'Annual',
        '325': 'Quarterly',
        '326': 'Bi-Monthly',
        '327': 'Monthly',
        '328': 'Quarterly',
        '329': 'Weekly'
    };

    const nextPage = () => {
        setCurrentPage(2);
    };

    const editApplication = () => {
        // Convert form data back to query parameters
        const queryString = new URLSearchParams(formData).toString();
        navigate(`/auto-application?${queryString}`);
    };

    const submitApplication = () => {
        if (!disclosureAccepted) {
            alert("Please accept the disclosures to submit the application.");
            return;
        }
        // Navigate to EndPage with form data
        navigate('/end-page', { state: { formData } });
    };

    return (
        <div className="review-page">
            <SideMenu menuItems={menuItems} />
            {isCollapsed && <TopMenu />}
            <div className="main-content">
                <div className="container">
                    <div className="content">
                        <div className={`page ${currentPage === 1 ? 'active' : ''}`}>
                            <h1>Review Your Application!</h1>
                            <p>Below is the information to be sent.</p>

                            {/* Loan Details Section */}
                            <div className="section">
                                <h3>Application Details</h3>
                                <div className="loan-info">
                                    {formData.loanTerm && (
                                        <p><strong>Term:</strong> {formData.loanTerm} months</p>
                                    )}
                                    {formData.interestRate && (
                                        <p><strong>Rate:</strong> {formData.interestRate}%</p>
                                    )}
                                    {formData.requestedAmount && (
                                        <p><strong>Requested Amount:</strong> ${formData.requestedAmount}</p>
                                    )}
                                    {formData.unsecuredLoanPurpose && (
                                        <p><strong>Loan Purpose:</strong> {formData.unsecuredLoanPurpose}</p>
                                    )}
                                </div>
                            </div>

                            {/* Personal Information Section */}
                            <div className="section">
                                <h3>Personal Information</h3>
                                {formData.firstName && <p><strong>First Name:</strong> {formData.firstName}</p>}
                                {formData.middleName && <p><strong>Middle Name:</strong> {formData.middleName}</p>}
                                {formData.lastName && <p><strong>Last Name:</strong> {formData.lastName}</p>}
                                {formData.suffix && <p><strong>Suffix:</strong> {formData.suffix}</p>}
                                {formData.birthDate && <p><strong>Birth Date:</strong> {formData.birthDate}</p>}
                                {formData.ssn && <p><strong>SSN:</strong> {formData.ssn}</p>}
                            </div>

                            {/* Address Information Section */}
                            <div className="section">
                                <h3>Address Information</h3>
                                {formData.addressLine1 && <p><strong>Address Line 1:</strong> {formData.addressLine1}</p>}
                                {formData.addressLine2 && <p><strong>Address Line 2:</strong> {formData.addressLine2}</p>}
                                {formData.city && <p><strong>City:</strong> {formData.city}</p>}
                                {formData.state && <p><strong>State:</strong> {formData.state}</p>}
                                {formData.zipCode && <p><strong>Zip Code:</strong> {formData.zipCode}</p>}
                            </div>

                            {/* Housing Information Section */}
                            <div className="section">
                                <h3>Housing Information</h3>
                                {formData.housing && <p><strong>Housing Status:</strong> {formData.housing}</p>}
                                {formData.housingPayment && <p><strong>Monthly Housing Payment:</strong> ${formData.housingPayment}</p>}
                            </div>

                            {/* Income Information Section */}
                            <div className="section">
                                <h3>Income Information</h3>
                                {formData.incomeSource && <p><strong>Income Source:</strong> {formData.incomeSource}</p>}
                                {formData.occupation && <p><strong>Occupation:</strong> {formData.occupation}</p>}
                                {formData.incomeFrequency && (
                                    <p><strong>Income Frequency:</strong> {incomeFrequencyMap[formData.incomeFrequency] || formData.incomeFrequency}</p>
                                )}
                                {formData.incomeAmount && <p><strong>Income Amount:</strong> ${formData.incomeAmount}</p>}
                                {formData.employmentYears && <p><strong>Years of Employment:</strong> {formData.employmentYears}</p>}
                                {formData.employmentMonths && <p><strong>Months of Employment:</strong> {formData.employmentMonths}</p>}
                            </div>

                            {/* Additional Income Section */}
                            {(formData.additionalIncomeSource || formData.additionalIncomeType || 
                              formData.additionalIncomeFrequency || formData.additionalIncomeAmount) && (
                                <div className="section">
                                    <h3>Additional Income Information</h3>
                                    {formData.additionalIncomeSource && (
                                        <p><strong>Additional Income Source:</strong> {formData.additionalIncomeSource}</p>
                                    )}
                                    {formData.additionalIncomeType && (
                                        <p><strong>Additional Income Type:</strong> {formData.additionalIncomeType}</p>
                                    )}
                                    {formData.additionalIncomeFrequency && (
                                        <p><strong>Additional Income Frequency:</strong> {formData.additionalIncomeFrequency}</p>
                                    )}
                                    {formData.additionalIncomeAmount && (
                                        <p><strong>Additional Income Amount:</strong> ${formData.additionalIncomeAmount}</p>
                                    )}
                                </div>
                            )}

                            {/* Contact Information Section */}
                            <div className="section">
                                <h3>Contact Information</h3>
                                {formData.homePhone && <p><strong>Home Phone:</strong> {formData.homePhone}</p>}
                                {formData.mobilePhone && <p><strong>Mobile Phone:</strong> {formData.mobilePhone}</p>}
                                {formData.workPhone && <p><strong>Work Phone:</strong> {formData.workPhone}</p>}
                                {formData.email && <p><strong>Email:</strong> {formData.email}</p>}
                            </div>

                            {/* Vehicle Information Section */}
                            {(formData.vin || formData.year || formData.make || formData.model || 
                              formData.trim || formData.estimatedValue || formData.mileage) && (
                                <div className="section">
                                    <h3>Vehicle Information</h3>
                                    {formData.vin && <p><strong>VIN:</strong> {formData.vin}</p>}
                                    {formData.year && <p><strong>Year:</strong> {formData.year}</p>}
                                    {formData.make && <p><strong>Make:</strong> {formData.make}</p>}
                                    {formData.model && <p><strong>Model:</strong> {formData.model}</p>}
                                    {formData.trim && <p><strong>Trim:</strong> {formData.trim}</p>}
                                    {formData.estimatedValue && <p><strong>Estimated Value:</strong> ${formData.estimatedValue}</p>}
                                    {formData.mileage && <p><strong>Mileage:</strong> {formData.mileage}</p>}
                                    {formData.gapInsurance && <p><strong>GAP Insurance:</strong> Yes</p>}
                                </div>
                            )}

                            <div className="button-group">
                                <button className="btn primary" onClick={nextPage}>Review Disclosures</button>
                                <button className="btn secondary" onClick={editApplication}>Edit Application</button>
                            </div>
                        </div>

                        <div className={`page ${currentPage === 2 ? 'active' : ''}`}>
                            <h2>Disclosures</h2>
                            
                            <div className="disclosures">
                                <h3>Credit Report Disclosure:</h3>
                                <p>By clicking the 'Submit' button I/we authorize the lender to obtain a credit report and process this loan application.</p>

                                <h3>Loan Confirmation Disclosure:</h3>
                                <p>By clicking the 'Submit' button you promise that everything you have stated in this application is true and correct to the best of your knowledge. You authorize the credit union to obtain credit reports for everyone listed on this loan application. You understand that the lender may offer a range of rates on their loan products and that the rate and term of your loan may depend upon an evaluation of your past credit history and any applicable discounts based upon your relationship with the credit union.</p>

                                <h3>Fact Act Notice Disclosure:</h3>
                                <p>We may furnish information about your account to consumer reporting agencies. Late or missed payments or other defaults on your account(s) could be reflected in your credit report.</p>

                                <h3>USA Patriot Act Disclosure:</h3>
                                <p>Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account. We will ask for your name, address, date of birth, and other information including valid identifying documents to identify you.</p>

                                <h3>Additional Disclosure:</h3>
                                <p>You agree that we may contact you by telephone at any telephone number associated with your account, including wireless telephone numbers, which could result in charges to you, in order to service your account for our own credit union marketing purposes. You further agree that methods of contact may include the use of short-message-service text messages, pre-recorded or artificial voice messages, and/or the use of an automatic dialing device. You authorize MAX Credit Union to contact you at the telephone number provided, even if you've previously registered on a Do Not Call registry. You understand that you are not required to consent to receiving auto-dialing calls/texts as a condition of purchasing any MAX products or services. Any cellular/mobile telephone number you provide may incur charges from your mobile service provider.</p>

                                {formData.loan_type === "Credit Card" && (
                                    <a href="https://www.mymax.com/assets/files/sCGyk5zF" target="_blank" rel="noopener noreferrer">
                                        Credit Card Application and Solicitation Disclosure
                                    </a>
                                )}
                            </div>

                            <div className="disclosure-acceptance">
                                <label className="checkbox-container">
                                    <input
                                        type="checkbox"
                                        checked={disclosureAccepted}
                                        onChange={(e) => setDisclosureAccepted(e.target.checked)}
                                    />
                                    I accept all disclosures
                                </label>
                            </div>

                            <div className="button-group">
                                <button 
                                    className="btn primary" 
                                    onClick={submitApplication}
                                    disabled={!disclosureAccepted}
                                >
                                    Submit Application
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReviewOffer;